import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('date.label', { count: 1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('type.label', { count: 1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('broadcast.model.label')} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('broadcast.important')} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('contract.category', { count: 1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('driver.label', { count: -1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('operator.label', { count: 1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('title.label', { count: 1 })} />
  </TableCell>
  <TableCell align={'center'}>
    <TextHeader label={I18n.t('body.label', { count: 1 })} />
  </TableCell>
</>

export default React.memo(Header)
